import React, { useEffect, useRef, useState } from 'react';

export const useAccessibility = () => {
  const [sitekey, setSitekey] = useState<string>('');
  const scriptEl = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    if (sitekey) {
      const position = window.innerWidth <= 800 ? 'Right' : 'Left';
      // @ts-ignore
      window.interdeal = {
        sitekey,
        Position: position,
        Menulang: 'EN-AU',
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        btnStyle: {
          vPosition: ['85%', '85%'],
          color: {
            main: '#000',
            second: '',
          },
          scale: ['0.55', '0.5'], // Size of the widget, left side is reffering to the desktop version, the right side is for mobile.
          icon: {
            type: 10,
            shape: 'semicircle',
          },
        },
      };

      ((doc, head, body) => {
        scriptEl.current = doc.createElement('script');
        scriptEl.current.src = 'https://cdn.equalweb.com/core/5.0.10/accessibility.js';
        scriptEl.current.defer = true;
        scriptEl.current.integrity = 'sha512-gKQdQe59Hw864B9Pbxo+0aPeJJQdKODsfg0Vwf+zIQcRS7uR+kd3oEX3ClAdDERLQbO5LmliXmzjNjrxkP5wgA==';
        scriptEl.current.crossOrigin = 'anonymous';
        scriptEl.current.setAttribute('data-cfasync', 'true');
        body ? body.appendChild(scriptEl.current) : head.appendChild(scriptEl.current);
      })(document, document.head, document.body);
    }

    return () => {
      scriptEl.current?.remove();
      scriptEl.current = null;
      document.querySelectorAll('[id^="IND"]').forEach((el) => el.remove());
      'interdeal' in window && delete window.interdeal;
    };
  }, [sitekey]);

  const shutdown = () => setSitekey('');

  return { setSitekey, shutdown };
};
